/*
 * Historico de snapshots del pendiente. El HTML original usaba window.storage
 * del visor; aca vive en localStorage, asi que el historico es por navegador.
 */

const STORAGE_KEY = "cartera-snapshots";

/**
 * Lee el historico guardado
 * @returns {Object} Mapa etiqueta → snapshot
 */
export const readSnapshots = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) ?? {};
  } catch (mError) {
    return {};
  }
};

/**
 * Guarda un snapshot bajo su etiqueta y devuelve el historico actualizado
 * @param {string} sLabel Etiqueta del snapshot (YYYY-MM-DD)
 * @param {Object} mSnapshot Datos del corte { total, count, byGer, savedAt }
 * @returns {Object} Historico actualizado
 */
export const saveSnapshot = (sLabel, mSnapshot) => {
  const mHistory = { ...readSnapshots(), [sLabel]: mSnapshot };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(mHistory));
  return mHistory;
};
